import { render, staticRenderFns } from "./Frog.vue?vue&type=template&id=97ec1dae&scoped=true&"
import script from "./Frog.vue?vue&type=script&lang=js&"
export * from "./Frog.vue?vue&type=script&lang=js&"
import style0 from "./Frog.vue?vue&type=style&index=0&id=97ec1dae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ec1dae",
  null
  
)

export default component.exports